module.exports = __webpack_public_path__ + "static/media/backend-info-small-screen.475e7615.png";